/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimesheetEntry } from './TimesheetEntry';
import {
    TimesheetEntryFromJSON,
    TimesheetEntryFromJSONTyped,
    TimesheetEntryToJSON,
    TimesheetEntryToJSONTyped,
} from './TimesheetEntry';

/**
 * 
 * @export
 * @interface ConfirmTimesheetEntryResponse
 */
export interface ConfirmTimesheetEntryResponse {
    /**
     * 
     * @type {TimesheetEntry}
     * @memberof ConfirmTimesheetEntryResponse
     */
    data: TimesheetEntry;
}

/**
 * Check if a given object implements the ConfirmTimesheetEntryResponse interface.
 */
export function instanceOfConfirmTimesheetEntryResponse(value: object): value is ConfirmTimesheetEntryResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ConfirmTimesheetEntryResponseFromJSON(json: any): ConfirmTimesheetEntryResponse {
    return ConfirmTimesheetEntryResponseFromJSONTyped(json, false);
}

export function ConfirmTimesheetEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmTimesheetEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': TimesheetEntryFromJSON(json['data']),
    };
}

  export function ConfirmTimesheetEntryResponseToJSON(json: any): ConfirmTimesheetEntryResponse {
      return ConfirmTimesheetEntryResponseToJSONTyped(json, false);
  }

  export function ConfirmTimesheetEntryResponseToJSONTyped(value?: ConfirmTimesheetEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TimesheetEntryToJSON(value['data']),
    };
}

